type ErrorResponse = {
  status: number;
  conflictData?: {
    errors?: Record<string, string>;
  };
};

const isConflictError = (error: unknown): error is { status: 409; conflictData: { errors: Record<string, string> } } =>
  !!(
    error &&
    typeof error === 'object' &&
    'status' in error &&
    error.status === 409 &&
    'conflictData' in error &&
    error.conflictData &&
    typeof error.conflictData === 'object' &&
    'errors' in error.conflictData &&
    error.conflictData.errors &&
    typeof error.conflictData.errors === 'object'
  );

export const getConflictErrorMessage = (error: unknown, errorKey: string): string | null => {
  if (isConflictError(error) && errorKey in error.conflictData.errors) {
    return (error as ErrorResponse).conflictData?.errors?.[errorKey] ?? null;
  }
  return null;
};

export const getFirstConflictErrorMessage = (error: unknown): string | null => {
  if (isConflictError(error)) {
    const messages = Object.values(error.conflictData.errors);

    return messages.length > 0 ? messages[0] : null;
  }
  return null;
};
